import voteTypes from 'constants/voteTypes';
import { Board, BoardOrder } from 'types';

export const getValidOrders = (board: Board): BoardOrder[] | undefined =>
  board?.orders?.filter(
    (order) => order.voteType === voteTypes.YES_NO_ABS.value
  );
